module.exports = __webpack_public_path__ + "img/Strategic_Leadership_circle.03bc5ad1.png";